/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `7` - Usual
 * * `2` - Minibus
 * * `3` - IntercityBus
 * * `4` - Taxi
 * * `5` - RentACar
 */
export enum OperatingModeEnum {
  '_7' = 7,
  '_2' = 2,
  '_3' = 3,
  '_4' = 4,
  '_5' = 5,
}
